export default __webpack_public_path__ + "static/media/Graphik-Regular.666f1412.ttf";